import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/action-types';

export default function setAuthRedirecting(): RootActionTypes {
  return {
    type: ActionTypes.REDIRECTING_TO_SHOPIFY_AUTH,
  };
}
